webpackJsonp([142629428675168],{

/***/ 509:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Jenny Marz Photography"}},"allMarkdownRemark":{"edges":[{"node":{"excerpt":"This is my first post on my new fake blog! How exciting! I’m sure I’ll write a lot more interesting things in the future. Oh, and here’s a…","fields":{"slug":"/hello-world/"},"frontmatter":{"date":"01 May, 2015","title":"Hello World"}}}]}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-3b840190781c1097ee9b.js